export default "__VITE_ASSET__d1dc1ad7__"